<template lang="pug">
.etapa-iara(v-if='etapaIARA')
    .linha
        b.coluna Informações Adicionais para a Regularização Ambiental
    .linha(:style='{ marginBottom : "30px"}')
        .coluna
            collapse-component(title='Atividades eventuais ou de baixo impacto', :isBasic='true')
                IaraEvenBaixoImpactoTable(
                    :atividadesBaixoImpacto="etapaIARA.atividadesBaixoImpacto",
                    :tipos-documentos='tiposDocumentos',
                    @itemValidados='validar($event)'
                )

    .linha(:style='{ marginBottom : "30px"}')
        .coluna
            collapse-component(title='Solicitação para autorização para o manejo de vegetação de reflorestamento em Reserva Legal', :isBasic='true')
                IaraSolicitacaoAutorizacaoTable(
                    :solicitacaoAutorizacaoManejo="etapaIARA.solicitacaoAutorizacaoManejo",
                    :tipos-documentos='tiposDocumentos',
                    @itemValidados='validar($event)'
                )

    .linha(:style='{ marginBottom : "30px"}')
        .coluna
            collapse-component(title='TAC, Decisões Judiciais e TCRAs', :isBasic='true')
                IaraTacDecJudiciaisTcrasTable(
                    :tacDecisoesJudiciaisTcras="etapaIARA.tacDecisoesJudiciaisTcras",
                    :tipos-documentos='tiposDocumentos',
                    @itemValidados='validar($event)'
                )
</template>

<script>
import { buscarEtapaIARA, salvar } from '@/services/etapa-iara.service';

import IaraEvenBaixoImpactoTable from '@/views/analise/components/etapaIARA/IaraEvenBaixoImpactoTable';
import IaraSolicitacaoAutorizacaoTable from '@/views/analise/components/etapaIARA/IaraSolicitacaoAutorizacaoTable';
import IaraTacDecJudiciaisTcrasTable from '@/views/analise/components/etapaIARA/IaraTacDecJudiciaisTcrasTable';

export default {
    components: {
        IaraEvenBaixoImpactoTable,
        IaraSolicitacaoAutorizacaoTable,
        IaraTacDecJudiciaisTcrasTable
    },
    props: {
        tiposDocumentos: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            idProcesso: this.$route.params.id,

            etapaIARA: {
                atividadesBaixoImpacto: [],
                solicitacaoAutorizacaoManejo: [],
                tacDecisoesJudiciaisTcras: [],
            },

            alteracoes: [],

            etapaIARAInicial: null,
        };
    },
    async mounted() {
        try {
            let responseEtapa = await buscarEtapaIARA(this.idProcesso);
            this.etapaIARA.atividadesBaixoImpacto = responseEtapa.atividadesBaixoImpacto.map(e => { return { ...e, acao: [{ id: 'MAP', label: 'Exibir mapa', icon: 'mdi-map' }, { id: 'DOC', label: 'Documentos', icon: 'mdi-text-box-search-outline' }] } });
            this.etapaIARA.solicitacaoAutorizacaoManejo = responseEtapa.solicitacaoAutorizacaoManejo;
            this.etapaIARA.tacDecisoesJudiciaisTcras = responseEtapa.tacDecisoesJudiciaisTcras.map(e => { return { ...e, acao: [{ id: 'MAP', label: 'Exibir mapa', icon: 'mdi-map' }, { id: 'DOC', label: 'Documentos', icon: 'mdi-text-box-search-outline' }] } });
            this.etapaIARA.processo = responseEtapa.processo;

        } catch {
            this.$router.push({ name: 'analise-proposta' });
        }
    },
    methods: {
        validar(item, validacao) {
            switch (item.key) {
                case 'ATIVIDADES_BAIXO_IMPACTO':
                    this.etapaIARA.atividadesBaixoImpacto = item.data;
                    break;
                case 'SOLICITACAO_AUTORIAZACAO':
                    this.etapaIARA.solicitacaoAutorizacaoManejo = item.data;
                    break;
                case 'TAC_DEC_JUDICIAIS':
                    this.etapaIARA.tacDecisoesJudiciaisTcras = item.data;
                    break;
                default:
                    break;
            }
        },

        async salvar() {
            const processo = await salvar(this.idProcesso, this.etapaIARA);
            if (processo) {
                this.$toast({
                    showClose: true,
                    message: 'Informações salvas com sucesso!',
                    type: 'success'
                });
                return processo;
            } else {
                return this.etapaIARA.processo;
            }
        },

    },



    watch: {
        etapaIARA: {
            deep: true,
            handler(novoValor) {
                if (!this.etapaIARAInicial) {
                // Se etapaIARAInicial ainda não foi definido, define-o agora
                    this.etapaIARAInicial = JSON.parse(JSON.stringify(novoValor));
                }
            }
        }
    }
};
</script>

<style scoped>
.titulo {
    padding: 40px 0px;
    font-weight: 600;
    font-size: 14px;
    color: var(--primary-black);
}

.mapa-iara {
    margin-right: 15px;
    color: var(--primary-black) !important;
}

.documento-iara {
    color: var(--primary-green) !important;
}
</style>
